import { alchemy } from '@account-kit/infra';
import { createLightAccountAlchemyClient } from '@account-kit/smart-contracts';
import { IxChain } from '@shared/src/config/chains';
import { getUnsafeSigner } from '@shared/src/lib/generateUnsafePrivateKey';
import { useHostStore } from '@shared/src/stores/useHostStore';

export type SingletonAccountClient = Awaited<ReturnType<typeof createLightAccountAlchemyClient>>;

// Minimal interface for the Light Account client that we actually use.
export const getSingletonAccountClient = async (
  chainId: number,
  address: `0x${string}`,
): Promise<SingletonAccountClient> => {
  const sdk = useHostStore.getState().sdk;
  if (!sdk) throw new Error('SDK not found, getting signleton Account');
  const alcchain = sdk.environment.SPONSORED_CHAINS.find(c => c.id === chainId);

  if (!alcchain) {
    console.error('alcchain', {
      alcchain,
      chainId,
      sponsoredChains: sdk.environment.SPONSORED_CHAINS,
    });
    throw 'this chain is not sponsored';
  }
  return await createLightAccountAlchemyClient({
    transport: alchemy({ apiKey: sdk.environment.ALCHEMY_API_KEY }),
    chain: alcchain,
    accountAddress: '0xceea278d6b2e18353e6313ae94389b135fd4694b',
    signer: getUnsafeSigner(alcchain, address),
    policyId: sdk.environment.ALCHEMY_GAS_POLICY_ID,
  });
};
